





import Vue from 'vue'
import {DateTime, Duration} from 'luxon'
export default Vue.extend({
  name: 'UiTimer',
  props: {
    timeNow: {
      type: [Number, String],
      default: ''
    },
    timeExp: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      dateNow: DateTime.fromMillis(this.timeNow as number) as DateTime,
      dateBeg: DateTime.fromMillis(this.timeExp as number) as DateTime
    }
  },
  methods: {
    start () {
      setInterval(() => {
        this.dateNow = this.dateNow.plus({seconds: 1})
      }, 1000)
    },
  },
  computed: {
    timer (): string {
      const diff: Duration = this.dateBeg.diff(this.dateNow).shiftTo('hours', 'minutes', 'seconds')
      let format = ''
      if (diff.hours > 0) {
        format += `h ${this.$t('labels.hour_short')}`
      }

      if (diff.minutes > 0) {
        format += `m ${this.$t('labels.minutes_short')}`
      }

      if (diff.seconds > 0) {
        format += `s ${this.$t('labels.seconds_short')}`
      }
      return diff.toFormat(format)
    },
    isExpired (): boolean {
      return this.timer ? false : true;
    }
  },
  mounted () {
    this.start();
  },
  watch: {
    isExpired () {
      if (this.isExpired) {
        this.$emit('expired')
      }
    },
    timeExp () {
      this.dateBeg = DateTime.fromMillis(this.timeExp as number) as DateTime
    }
  }
})
